import { localStorage } from '@rover/utilities/storage';

export const getItem = (key: string): string | null => localStorage.getItem(key);

export const setItem = (key: string, value: string): void => localStorage.setItem(key, value);

export const removeItem = (key: string): void => localStorage.removeItem(key);

export const clear = (): void => localStorage.clear();
